<script setup lang="ts">
import { onMounted, provide, ref } from 'vue'
import AboutPage from './AboutPage.vue'
import SearchPage from './SearchPage.vue'
import ExpansionsPage from './ExpansionsPage.vue'
import {
  usePlaywire, addPlaywireUnit, destroyPlaywireUnits,
  type Parallel, type Supporter, DialogManager } from '@wastedondestiny/destiny-library'

const { waitForRamp } = usePlaywire()
const supporters = ref<Supporter[]>([])
const parallel = ref<Parallel[]>([])

const apiUrl = import.meta.env.VITE_API_URL

async function loadSupporters() {
  const supportersRequest = await fetch(`${apiUrl}/supporters`)
  const supportersResponse = await supportersRequest.json()
  supporters.value = supportersResponse
}

async function loadParallel() {
  const parallelRequest = await fetch('https://b.vlsp.network/Public/ParallelPrograms')
  const parallelResponse = await parallelRequest.json()
  parallel.value = parallelResponse.Response
}

onMounted(() => {
  loadSupporters().catch(() => {})
  loadParallel().catch(() => {})

  const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1))
  idle(() => {
    const s = document.createElement('script')
    s.src = '//cdn.intergient.com/1025583/76085/ramp.js'
    s.async = true
    s.setAttribute('data-cfasync', 'false')
    document.body.appendChild(s)
  })
  idle(async () => {
    try {
      await waitForRamp()
      destroyPlaywireUnits()
      addPlaywireUnit('standard_iab_foot1', 'footer')
      addPlaywireUnit('standard_iab_foot2', 'footer-bottom')
      addPlaywireUnit('standard_iab_rght1', 'siderail-home-right')
      addPlaywireUnit('standard_iab_left1', 'siderail-home-left')
      addPlaywireUnit('bottom_rail')
    } catch (_) {}
  })
})

provide('supporters', supporters)
provide('parallel', parallel)
</script>

<template>
  <DialogManager :api-url="apiUrl">
    <template #default="{ hasDialogs }">
      <div :class="{ 'h-[calc(100vh-4rem)] overflow-hidden pointer-events-none': hasDialogs }">
        <SearchPage />
        <ExpansionsPage />
        <AboutPage />
      </div>
      <div id="siderail-home-left" class="fixed left-0 top-0 w-48 h-full hidden xl:flex justify-center items-center pointer-events-none *:pointer-events-auto"></div>
      <div id="siderail-home-right" class="fixed right-0 top-0 w-48 h-full hidden xl:flex justify-center items-center pointer-events-none *:pointer-events-auto"></div>
    </template>
  </DialogManager>
</template>
